import { useTranslation } from 'react-i18next';
import type { SettingsPasswordFormProps } from './SettingsPasswordForm.types';

export const useSettingsPasswordForm = (props: SettingsPasswordFormProps) => {
  const { t } = useTranslation();
  return { t, ...props };
};
